import BrTableV2 from './BrTableV2';
import BrColumn from './BrColumn';
import * as Columns from './columns';

BrTableV2.Columns = Columns;
BrTableV2.BrColumn = BrColumn;
export default BrTableV2;
